import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, useStore } from "react-redux";
import listSaveMiddleware from "../listSaveMiddleware";
import appReducer from "./appSlice";
import armyReducer from "./armySlice";
import communityReducer from "./communitySlice";
import ftlReducer from "./ftlSlice";
import listReducer from "./listSlice";
import questReducer from "./questSlice";
import rulesReducer from "./rulesSlice";
import studioReducer from "./studioSlice";
import unitsReducer from "./unitsSlice";

export const makeStore = () =>
  configureStore({
    reducer: {
      ftl: ftlReducer,
      army: armyReducer,
      community: communityReducer,
      list: listReducer,
      units: unitsReducer,
      app: appReducer,
      quest: questReducer,
      rules: rulesReducer,
      studio: studioReducer
    },
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware().concat(listSaveMiddleware); //.concat(consoleLogMiddleware);
    }
  });

export const store = makeStore();

if (typeof window !== "undefined") {
  (window as any).store = store;
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppStore = useStore.withTypes<AppStore>();
export const useAppSelector = useSelector.withTypes<RootState>();
